import { Link } from "@/lib/router-compat";
import type { ListingLink } from "@/lib/listingLinks";

interface SsrLinkGridProps {
  title: string;
  links: ListingLink[];
  description?: string;
}

/**
 * Server-rendered grid of internal links. Present in the initial HTML so
 * search engines and AI crawlers can discover individual pages without
 * executing JavaScript.
 */
const SsrLinkGrid = ({ title, links, description }: SsrLinkGridProps) => {
  if (!links || links.length === 0) return null;

  return (
    <nav aria-label={title} className="border-t border-border bg-muted/30">
      <div className="container mx-auto px-4 py-10">
        <h2 className="text-xl font-semibold text-foreground mb-2">{title}</h2>
        {description && (
          <p className="text-sm text-muted-foreground mb-4">{description}</p>
        )}
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-2">
          {links.map((link) => (
            <li key={link.path} className="min-w-0">
              <Link
                to={link.path}
                className="text-sm text-muted-foreground hover:text-primary hover:underline break-words"
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default SsrLinkGrid;
